module.exports = __webpack_public_path__ + "img/BLANCO_Aprendizaje.3988b44c.png";